// ABOUTME: Small icon shown next to a status label that reveals a short explanation on hover or tap.
// ABOUTME: Used where a status is accurate but hides something the reader still needs to see.
import { Box, useTheme } from "@mui/material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { tokens } from "../../../theme";
import SHQuickAction from "../Modal/SHQuickAction";
import Text from "../text/Text";

const LabelNotice = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <SHQuickAction
            maxWidth={260}
            component={<Text>{props.text}</Text>}
        >
            {(handlers) => (
                <Box
                    {...handlers}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        color: colors.red[400],
                        cursor: "pointer",
                    }}
                >
                    <HighlightOffIcon fontSize="small"/>
                </Box>
            )}
        </SHQuickAction>
    );
};

export default LabelNotice;
